import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import TasktypeDashboard from '../TasktypeDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function TasktypePage() {
    const dispatch = useDispatch();
    const { TasktypeList} = useSelector((state)=>state.manufaslice)
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < TasktypeDashboard />
    )

}